/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistAliasCreateSourceIdsSpotifyInner } from './ArtistAliasCreateSourceIdsSpotifyInner';
import {
    ArtistAliasCreateSourceIdsSpotifyInnerFromJSON,
    ArtistAliasCreateSourceIdsSpotifyInnerFromJSONTyped,
    ArtistAliasCreateSourceIdsSpotifyInnerToJSON,
} from './ArtistAliasCreateSourceIdsSpotifyInner';

/**
 * 
 * @export
 * @interface ArtistAliasCreateSourceIds
 */
export interface ArtistAliasCreateSourceIds {
    /**
     * 
     * @type {Array<ArtistAliasCreateSourceIdsSpotifyInner>}
     * @memberof ArtistAliasCreateSourceIds
     */
    spotify?: Array<ArtistAliasCreateSourceIdsSpotifyInner>;
    /**
     * 
     * @type {Array<ArtistAliasCreateSourceIdsSpotifyInner>}
     * @memberof ArtistAliasCreateSourceIds
     */
    discogs?: Array<ArtistAliasCreateSourceIdsSpotifyInner>;
    /**
     * 
     * @type {Array<ArtistAliasCreateSourceIdsSpotifyInner>}
     * @memberof ArtistAliasCreateSourceIds
     */
    musicbrainz?: Array<ArtistAliasCreateSourceIdsSpotifyInner>;
    /**
     * 
     * @type {Array<ArtistAliasCreateSourceIdsSpotifyInner>}
     * @memberof ArtistAliasCreateSourceIds
     */
    deezer?: Array<ArtistAliasCreateSourceIdsSpotifyInner>;
}

/**
 * Check if a given object implements the ArtistAliasCreateSourceIds interface.
 */
export function instanceOfArtistAliasCreateSourceIds(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ArtistAliasCreateSourceIdsFromJSON(json: any): ArtistAliasCreateSourceIds {
    return ArtistAliasCreateSourceIdsFromJSONTyped(json, false);
}

export function ArtistAliasCreateSourceIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistAliasCreateSourceIds {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'spotify': !exists(json, 'spotify') ? undefined : ((json['spotify'] as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerFromJSON)),
        'discogs': !exists(json, 'discogs') ? undefined : ((json['discogs'] as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerFromJSON)),
        'musicbrainz': !exists(json, 'musicbrainz') ? undefined : ((json['musicbrainz'] as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerFromJSON)),
        'deezer': !exists(json, 'deezer') ? undefined : ((json['deezer'] as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerFromJSON)),
    };
}

export function ArtistAliasCreateSourceIdsToJSON(value?: ArtistAliasCreateSourceIds | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'spotify': value.spotify === undefined ? undefined : ((value.spotify as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerToJSON)),
        'discogs': value.discogs === undefined ? undefined : ((value.discogs as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerToJSON)),
        'musicbrainz': value.musicbrainz === undefined ? undefined : ((value.musicbrainz as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerToJSON)),
        'deezer': value.deezer === undefined ? undefined : ((value.deezer as Array<any>).map(ArtistAliasCreateSourceIdsSpotifyInnerToJSON)),
    };
}

